var map = {
	"./apple-touch-icon-114x114.png": "piQn",
	"./apple-touch-icon-120x120.png": "gVnZ",
	"./apple-touch-icon-144x144.png": "y7Wv",
	"./apple-touch-icon-152x152.png": "8g4X",
	"./apple-touch-icon-57x57.png": "N8m+",
	"./apple-touch-icon-60x60.png": "GNXv",
	"./apple-touch-icon-72x72.png": "ESh/",
	"./apple-touch-icon-76x76.png": "JL1o",
	"./favicon-128.png": "QZk5",
	"./favicon-16x16.png": "qRiL",
	"./favicon-196x196.png": "dzbc",
	"./favicon-32x32.png": "L5AL",
	"./favicon-96x96.png": "bBWR",
	"./favicon.ico": "YPNG",
	"./mstile-144x144.png": "AvQr",
	"./mstile-150x150.png": "Sd8+",
	"./mstile-310x150.png": "afAO",
	"./mstile-310x310.png": "Agi5",
	"./mstile-70x70.png": "DNJX"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "x25e";